import { forwardRef, useCallback, useRef } from 'react';

import { Clickable } from '~shared/ui/clickable';

import { Int16Calendar } from '@platform-ui/iconsPack';
import { InputNoFocus } from '@platform-ui/input';

import { getRealRange } from '../../lib/get-real-range';

type Props = {
  value: string;
  onClick: () => void;
};

export const CustomInput = forwardRef(
  ({ value = '', onClick }: Partial<Props>, forwardedRef: any) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    const setRef = useCallback((element: HTMLInputElement | null) => {
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else {
        inputRef.current = element;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        forwardedRef = inputRef;
      }
    }, []);

    return (
      <Clickable
        onClick={() => {
          onClick?.();
          inputRef.current?.focus();
        }}
      >
        <div className="pointer-events-none">
          <InputNoFocus
            value={getRealRange(value)}
            forwardedRef={setRef}
            cursor="pointer"
            placeholder="Click to select a period"
            size="m"
            onChange={() => {}}
            inputIcon={
              <div className="ml-3 flex items-center pt-[2px]">
                <Int16Calendar theme="gray" />
              </div>
            }
          />
        </div>
      </Clickable>
    );
  }
);
CustomInput.displayName = 'CustomInput';
